import {useQuery} from "@tanstack/react-query";
import {getMyProfileGamerService} from "../services/gamification.service";
import {useAuthStore} from "../store/useAuth.store";
import {useIsGamanzaUiEnabled} from "../utils/gamanzaUi";

export const useGetMyProfileGamer = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const token = useAuthStore(state => state.token);
  const gamanzaUiEnabled = useIsGamanzaUiEnabled();
  const enabled = gamanzaUiEnabled && authStatus === "authenticated" && Boolean(token);

  const {data, isSuccess, refetch, isLoading, isFetching} = useQuery({
    queryKey: ["getMyProfileGamerService", token],
    queryFn: getMyProfileGamerService,
    enabled,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    isLoading: enabled && (isLoading || isFetching),
    isSuccess,
    refetch,
    data: data?.data?.data,
  };
};
